// src/routes/app.routes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Importando VegaPortal (novo portal institucional)
import VegaPortal from '../modules/Home';

// Importando nova página CADPro
import EngenhariaAplicada from '../modules/EngenhariaAplicada';

// Shop
import {
  CartProvider,
  ShopLayout,
  ShopHome,
  ProductDetail,
  Cart,
  Category
} from '../modules/Shop';

// Admin
import {
  AdminLayout,
  ProtectedRoute,
  Dashboard,
  BlogList,
  BlogEditor,
  Configuracoes,
  Leads,
  Analytics,
  MarketIntelligence,
  LinkedInCallback,
  Jobs,
  JobEditor,
  JobApplications,
  JobScriptEditor,
  Users,
  MeuManual,
  InvestorsAdmin,
  Goals,
  InvestorGoals,
  ExpenseDeclarations,
  Products,
  ProductEditor,
  Orders
} from '../modules/Admin';

// Investors
import {
  InvestorLayout,
  InvestorProtectedRoute,
  InvestorLogin,
  InvestorDashboard
} from '../modules/Investors';

// Careers
import Careers from '../modules/Careers';
import JobDetail from '../modules/Careers/JobDetail';

// Blog público
import Blog from '../modules/Blog';
import BlogPost from '../modules/Blog/BlogPost';

// Legal
import Privacy from '../modules/Legal/Privacy';
import Terms from '../modules/Legal/Terms';

// Detecta o subdomínio atual
const getSubdomain = () => {
  const hostname = window.location.hostname;
  if (hostname === 'cadpro.vegarobotics.com.br') return 'cadpro';
  if (hostname === 'blog.vegarobotics.com.br') return 'blog';
  if (hostname === 'shop.vegarobotics.com.br') return 'shop';
  return 'main';
};

const AppRoutes = () => {
  const subdomain = getSubdomain();

  // CADPRO: cadpro.vegarobotics.com.br
  if (subdomain === 'cadpro') {
    return (
      <Routes>
        <Route path="/" element={<EngenhariaAplicada />} />
        <Route path="*" element={<EngenhariaAplicada />} />
      </Routes>
    );
  }

  // BLOG: blog.vegarobotics.com.br
  if (subdomain === 'blog') {
    return (
      <Routes>
        <Route path="/" element={<Blog />} />
        <Route path="/:slug" element={<BlogPost />} />
        <Route path="*" element={<Blog />} />
      </Routes>
    );
  }

  // SHOP: shop.vegarobotics.com.br
  if (subdomain === 'shop') {
    return (
      <CartProvider>
        <Routes>
          <Route path="/" element={<ShopLayout />}>
            <Route index element={<ShopHome />} />
            <Route path="categoria/:slug" element={<Category />} />
            <Route path="produto/:slug" element={<ProductDetail />} />
            <Route path="carrinho" element={<Cart />} />
            <Route path="favoritos" element={<ShopHome />} />
            <Route path="conta" element={<ShopHome />} />
            <Route path="*" element={<ShopHome />} />
          </Route>
        </Routes>
      </CartProvider>
    );
  }

  // MAIN: www.vegarobotics.com.br
  return (
    <Routes>
      {/* Home */}
      <Route path="/" element={<VegaPortal />} />

      {/* Legal */}
      <Route path="/privacidade" element={<Privacy />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/termos" element={<Terms />} />
      <Route path="/terms" element={<Terms />} />

      {/* Careers */}
      <Route path="/carreiras" element={<Careers />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/carreiras/:slug" element={<JobDetail />} />
      <Route path="/careers/:slug" element={<JobDetail />} />

      {/* Admin */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute requireAdmin>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="blog" element={<BlogList />} />
        <Route path="blog/novo" element={<BlogEditor />} />
        <Route path="blog/editar/:id" element={<BlogEditor />} />
        <Route path="leads" element={<Leads />} />
        <Route path="produtos" element={<Products />} />
        <Route path="produtos/novo" element={<ProductEditor />} />
        <Route path="produtos/editar/:id" element={<ProductEditor />} />
        <Route path="pedidos" element={<Orders />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="inteligencia" element={<MarketIntelligence />} />
        <Route path="configuracoes" element={<Configuracoes />} />
        <Route path="linkedin/callback" element={<LinkedInCallback />} />
        <Route path="vagas" element={<Jobs />} />
        <Route path="vagas/nova" element={<JobEditor />} />
        <Route path="vagas/editar/:id" element={<JobEditor />} />
        <Route path="vagas/:id/candidaturas" element={<JobApplications />} />
        <Route path="vagas/:id/script" element={<JobScriptEditor />} />
        <Route path="usuarios" element={<Users />} />
        <Route path="meu-manual" element={<MeuManual />} />
        <Route path="investidores" element={<InvestorsAdmin />} />
        <Route path="metas" element={<Goals />} />
        <Route path="metas-investidores" element={<InvestorGoals />} />
        <Route path="gastos" element={<ExpenseDeclarations />} />
      </Route>

      {/* Investor Portal */}
      <Route path="/investidores/login" element={<InvestorLogin />} />
      <Route
        path="/investidores"
        element={
          <InvestorProtectedRoute>
            <InvestorLayout />
          </InvestorProtectedRoute>
        }
      >
        <Route index element={<InvestorDashboard />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<VegaPortal />} />
    </Routes>
  );
};

export default AppRoutes;
